export default __webpack_public_path__ + "assets/mahahual.21659746.jpg";